import React from "react";
import PropTypes from "prop-types";
import { fromJS } from "immutable";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  Icon,
  SearchPropTypes,
  CompanyName,
  PartNumber
} from "MODULES/shared/components";
import {
  DATE_RECEIVED,
  getConditionAbbrev
} from "MODULES/RepairOrders/constants";
import {
  INVENTORY,
  SERIAL_NUMBER,
  STORE_OWNER_ID
} from "MODULES/inventories/constants";
import { DESCRIPTION, PART } from "MODULES/parts/constants";
import { CANCELLED, CREATED_AT, ID, UUID } from "APP_ROOT/constants";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import StatusBadges from "MODULES/RepairOrders/components/Detail/LineItems/StatusBadges";
import {
  LABOR_COST,
  OUTSIDE_LABOR_COST,
  PART_COST
} from "MODULES/SalesOrders/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ExchangeIcon, getCap, totalCostEvalColumn } from "../../helpers";
import LocationFlag from "../../../shared/components/LocationFlag/LocationFlag";

function renderRow(result, pushHistory) {
  const lineItem = fromJS(result);
  const rowClasses = classNames("clickable", {
    "cancelled-item": lineItem.get(CANCELLED)
  });

  const cap = getCap(lineItem);
  const totalLabor =
    parseFloat(lineItem.get(LABOR_COST) || 0) +
    parseFloat(lineItem.get(OUTSIDE_LABOR_COST) || 0);

  let tooltipText = "";
  if (cap.includes("green-table-cap")) {
    tooltipText = "Approved, pending receipt.";
  } else if (cap.includes("warning-table-cap")) {
    tooltipText = "Sellable, pending receipt";
  } else if (cap.includes("danger-table-cap")) {
    tooltipText = "Do not sell, pending receipt.";
  }

  const tooltip = <Tooltip>{tooltipText}</Tooltip>;

  return (
    <tr
      key={lineItem.get(ID)}
      className={rowClasses}
      onClick={() =>
        pushHistory(`/repair-orders/${lineItem.get("repair_order_uuid")}`)}
    >
      <OverlayTrigger placement="top" overlay={tooltip}>
        <td className={cap}>
          {lineItem.get("repair_order_code")}{" "}
          {lineItem.get(CANCELLED) && (
            <span className="text-muted">
              <Icon name="ban" />
            </span>
          )}
        </td>
      </OverlayTrigger>
      <td className="text-center">
        <ExchangeIcon lineItem={lineItem.toJS()} />
      </td>
      <td>{shortDate(lineItem.get(CREATED_AT))}</td>
      <td>{shortDate(lineItem.get(DATE_RECEIVED))}</td>
      <td>
        <CompanyName
          flattenedCompany={lineItem.toJS()}
          context="repair"
          truncateAt={25}
        />
      </td>
      <td className="text-center">
        <LocationFlag location={lineItem.getIn([INVENTORY, STORE_OWNER_ID])} />
      </td>
      <td>
        <PartNumber part={lineItem.toJS().part} />
      </td>
      <Link
        onClick={e => e.stopPropagation()}
        to={`/inventories/${lineItem.getIn([INVENTORY, UUID])}`}
      >
        {lineItem.get("original_serial_number") || lineItem.get(SERIAL_NUMBER)}
      </Link>
      <td>{lineItem.get(PART).get(DESCRIPTION)}</td>
      <td>{getConditionAbbrev(lineItem.get("condition_sent"))}</td>
      <td>{getConditionAbbrev(lineItem.get("inventory_condition"))}</td>
      <td>{<StatusBadges lineItem={lineItem.toJS()} />}</td>
      <td>{shortDate(lineItem.get("expected_date"))}</td>
      <td>{lineItem.get("invoice_number")}</td>
      <td>{shortDate(lineItem.get("invoice_due_date"))}</td>
      <td>{shortDate(lineItem.get("eval_due_date"))}</td>
      <td>{dollars(lineItem.get("original_evaluation"))}</td>
      <td>{dollars(lineItem.get(PART_COST))}</td>
      <td>{dollars(totalLabor)}</td>
      <td>{totalCostEvalColumn(lineItem.toJS())}</td>
      <NoteTooltipTableCell note={lineItem.get("last_ro_note")} />
    </tr>
  );
}

export function Table({ pushHistory, isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>RO #</th>
        <th>Exch</th>
        <th>Date Created</th>
        <th>Date Received</th>
        <th>Repair Station</th>
        <th>Store Owner</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Description</th>
        <th>CD Sent</th>
        <th>Inv CD</th>
        <th>Eval Status</th>
        <th>Expected Date</th>
        <th>Inv #</th>
        <th>Inv Due Date</th>
        <th>Eval Due Date</th>
        <th>Original Eval</th>
        <th>Parts</th>
        <th>Labor</th>
        <th>Total/Eval</th>
        <th>Note</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, {
  pushHistory: push
})(Table);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Search/Table.jsx